import {
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react'

export type TrailingBadgeContextProps = {
  /**
   * The badge after the title of the list item. Used for the aria-label of the list item
   */
  trailingBadge: string
  setTrailingBadge: Dispatch<SetStateAction<string>>
}

const TrailingBadgeContext = createContext<TrailingBadgeContextProps | undefined>(undefined)

export const TrailingBadgeProvider = ({children}: PropsWithChildren) => {
  const [trailingBadge, setTrailingBadge] = useState('')
  const contextProps = useMemo(
    () => ({trailingBadge, setTrailingBadge}) satisfies TrailingBadgeContextProps,
    [trailingBadge],
  )
  return <TrailingBadgeContext.Provider value={contextProps}>{children}</TrailingBadgeContext.Provider>
}

export const useListItemTrailingBadge = () => {
  const context = useContext(TrailingBadgeContext)
  if (!context) throw new Error('useListItemTrailingBadge must be used with TrailingBadgeProvider.')
  return context
}

try{ TrailingBadgeContext.displayName ||= 'TrailingBadgeContext' } catch {}
try{ TrailingBadgeProvider.displayName ||= 'TrailingBadgeProvider' } catch {}